import * as React from "react";
import * as S from "@styled";
import * as AppPath from "../model/AppPath";

import { default as ActionMenu } from "./ActionMenu";
import { default as RunOnceDialog } from "./dialogs/RunOnceDialog";

import { AgentGroup } from "../../shared/model/AgentGroup";
import { HashMap } from "../../shared/model/HashMap";
import { getEditLink } from "../model/AppLinks";
import { Process } from "../model/Process";
import { ProcessAggregateCount } from "../model/ProcessAggregateCount";
import LogLevelSettingsDialog from "./dialogs/LogLevelSettingDialog";
import { PageLoadSpinner } from "shared/components/PageLoadSpinner";
import useUserTheme from "shared/styles/hooks/useUserTheme";
import { ThemeType } from "shared/styles/theme";

// webpackChunkName does not work for some reason
const ProcessInstanceListPage = React.lazy(() => import(/* webpackChunkName: "processInstanceList" */ "../../processInstanceList"));

export const ProcessInstanceListWrapper: React.FC<ProcessInstanceListWrapperProps> = (props) => {
    const spinner = <PageLoadSpinner />;
    const [theme] = useUserTheme();

    if (Object.keys(props.agentGroups).length === 0) {
        // Avoid race condition where agent groups are not in the store yet, but they
        // are needed in early lifecycle methods of the process instance list page
        return spinner;
    }

    const actionMenuLabelComponent = (
        <S.Button style={{ width: "100%", justifyContent: "flex-end" }}>
            {!AppPath.isSubprocessList() ? FRENDS.Localizations.ProcessActions : "Subprocess actions"}&nbsp;<i style={{ color: theme === ThemeType.light ? S.Colors.purplePrimary : S.Colors.white }} className="ci-chevron_down" />
        </S.Button>
    )

    return <React.Suspense fallback={spinner}>
        <ProcessInstanceListPage
            agentGroups={props.agentGroups}
            processDetails={props.selectedProcesses.map((p) => ({ name: p.name, uniqueIdentifier: p.uniqueIdentifier, processId: p.id }))}
            processAggregateCounts={props.countsForInstanceProcess}
            hasProcessInstanceEditPermission={props.hasProcessInstanceEditPermission}
            processActionMenu={props.selectedProcesses.length === 1 ?
                <ActionMenu
                    instanceList={true}
                    labelComponent={actionMenuLabelComponent}
                    editLink={getEditLink(props.selectedProcesses[0].id)}
                    processIds={props.selectedProcesses.map((x) => x.id)}
                /> : null}
        />
        <LogLevelSettingsDialog />
        <RunOnceDialog />
    </React.Suspense>;
};

interface ProcessInstanceListWrapperProps {
    agentGroups: HashMap<AgentGroup>;
    selectedProcesses: Process[];
    countsForInstanceProcess: ProcessAggregateCount;
    hasProcessInstanceEditPermission: boolean;
    currentAgentGroup: string;
}

export default ProcessInstanceListWrapper;
